import { Component, OnInit, EventEmitter } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { PackageService } from '../../common/package.service';

@Component({
  selector: 'supplier-membership-form',
  templateUrl: './supplier-membership-form.component.html',
  styleUrls: ['./supplier-membership-form.component.css', '../../app.component.css'],
  providers: [PackageService],
})
export class SupplierMembershipFormComponent implements OnInit {

 packageForm: any;
 eventId: any;
 packageId: any;
 package: any;
 spinner: boolean = false;

 constructor(private formBuilder: FormBuilder, private packageService: PackageService, private activatedRoute: ActivatedRoute){
  this.packageForm = this.formBuilder.group({
   'id': [''],
   'name': ['', Validators.required],
   'price': ['', Validators.required],
   'quantity': ['', Validators.required],
   'freeAttendeesCount': ['', Validators.required],
   'extraAttendeePrice': ['', Validators.required],
  });
  this.package = this.packageForm.value;
  this.activatedRoute.queryParams.subscribe((params: Params) => {
   this.eventId = params.id;
  });
 }

 ngOnInit() {
 }

 onSave = new EventEmitter();

 savePackage() {
  if(this.packageForm.valid)
  {
   this.spinner = true;
   var params = this.packageForm.value;
   params.eventId = this.eventId;
   this.packageService.saveSupplierPackage(params).subscribe(
    response => {
     this.spinner = false;
     if(response.status)
     this.onSave.emit();
    },
    error => {
     this.spinner = false;
    }
   );
  }
 }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/supplier-membership-form/supplier-membership-form.component.ts